import React from 'react'

export default ({ children }) => (
  <div className="layout-wrapper">{children}</div>
)
